export default {
  stories: undefined,
  storiesList: undefined,
  selectedStorie: undefined,
  showStories: false,
  showProactiveMsg: false,
  vueperStoriesDisabled: false,
  manualCloseProactiveMessage: false
}
